import { useQuery } from "@tanstack/react-query";
import FeedbackService from "@/shared/services/feedback.service";

export const useGetFeedbackList = () => {
  return useQuery(['get feedback list'], () => FeedbackService.getList(), {
    retry: 0
  })
}